import React from 'react';
import {
    Redirect
} from 'react-router-dom'

const MainPage = () => (
    <Redirect to="/login" />
);

export default MainPage;


// WEBPACK FOOTER //
// ./src/pages/MainPage.js